import {Show} from 'components';
import DisplayAndUpdateBillingAddress from 'components/payment/DisplayAndUpdateBillingAddress';
import DisplayAndUpdateDeliveryAddress from 'components/payment/DisplayAndUpdateDeliveryAddress';
import DisplayAndUpdatePaymentCard from 'components/payment/DisplayAndUpdatePaymentCard';
import {H6, P} from 'components/TypographyShortcuts';
import {UserContext} from 'context';
import {useContext} from 'react';
import {EndSection} from '..';

const PaymentAndDelivery = ({applicationType}) => {
    const {hasBillingInfo, hasDeliveryInfo, hasPaymentInfo} =
        useContext(UserContext);

    return (
        <EndSection
            buttonText='Create My Perfect Application'
            buttonDisabled={!(hasBillingInfo && hasPaymentInfo && hasDeliveryInfo)}
            endpointOverride={`application/${applicationType}/start`}
        >
            <H6>Payment and Delivery</H6>
            <P>
                In order to start an application we will need to keep a payment card
                on file, with correct billing and delivery addresses. If you haven't
                done so already, please enter a card below. Otherwise, please double
                check the card info, billing address, and delivery address.
            </P>
            <DisplayAndUpdateBillingAddress highlight={!hasBillingInfo} />
            <Show condition={!hasBillingInfo}>
                <P color='secondary'>Please enter Billing Address</P>
            </Show>
            <DisplayAndUpdatePaymentCard highlight={!hasPaymentInfo} />
            <Show condition={!hasPaymentInfo}>
                <P color='secondary'>Please enter a Payment Card</P>
            </Show>
            <DisplayAndUpdateDeliveryAddress highlight={!hasDeliveryInfo} />
            <Show condition={!hasDeliveryInfo}>
                <P color='secondary'>Please enter a Delivery Address</P>
            </Show>
        </EndSection>
    );
};

export default PaymentAndDelivery;
